import { render, staticRenderFns } from "./billing_address.vue?vue&type=template&id=74eb24e3&"
import script from "./billing_address.vue?vue&type=script&lang=js&"
export * from "./billing_address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports